<div class="table-footer" role="region" aria-label="Table footer">
  <!-- Left: Save button + status HUD -->
  <div class="footer-left" *ngIf="editable && !readonly">
    <button type="button" class="footer-btn save-btn"
      (click)="manualSave.emit()"
      [disabled]="saving || !hasUnsavedChanges"
      [attr.aria-label]="saving ? 'Saving…' : 'Save changes'">
      <lucide-angular name="save" [size]="13" aria-hidden="true"></lucide-angular>
    </button>

    <!-- Status / HUD text area -->
    <div class="hud-area">

      <!-- Default save status -->
      <ng-container *ngIf="!notification">
        <span *ngIf="saving" class="hud-label hud-label--saving" aria-live="polite">Saving…</span>
        <span *ngIf="!saving && lastSaved && !hasUnsavedChanges" class="hud-label" aria-live="polite">Saved {{ lastSavedText }}</span>
        <span *ngIf="!saving && hasUnsavedChanges" class="hud-label" aria-live="polite">Unsaved changes</span>
      </ng-container>

      <!-- Transient toast (copy / success) -->
      <span *ngIf="notification && notification.type !== 'error'"
            class="hud-toast"
            [class.hud-toast--visible]="notificationVisible"
            role="status"
            aria-live="polite">
        <lucide-angular name="check" [size]="11" aria-hidden="true"></lucide-angular>
        {{ notification.text }}
      </span>

      <!-- Inline error (no pill, no box, no dismiss) -->
      <span *ngIf="notification && notification.type === 'error'"
            class="hud-error"
            [class.hud-error--visible]="notificationVisible"
            role="alert">
        <span class="hud-error-text" [title]="notification.text">{{ notification.text }}</span>
      </span>

    </div>
  </div>
  <div class="footer-left" *ngIf="!editable || readonly"></div>

  <!-- Right: Record count + Page navigation grouped together -->
  <div class="footer-right">
    <div class="pagination-info" aria-live="polite">
      {{ paginationStart }}&ndash;{{ paginationEnd }} of {{ totalRecords }}
    </div>
    <div class="pagination-controls">
      <button type="button" class="footer-btn" (click)="currentPage > 0 && prev.emit()"
        [attr.aria-disabled]="currentPage <= 0 ? 'true' : null" aria-label="Previous page" title="Previous page">
        <lucide-angular name="chevron-left" [size]="14" aria-hidden="true"></lucide-angular>
      </button>
      <span class="page-indicator" aria-current="page">
        Page <strong>{{ currentPage + 1 }}</strong> of <strong>{{ totalPages }}</strong>
      </span>
      <button type="button" class="footer-btn" (click)="currentPage < totalPages - 1 && next.emit()"
        [attr.aria-disabled]="currentPage >= totalPages - 1 ? 'true' : null" aria-label="Next page" title="Next page">
        <lucide-angular name="chevron-right" [size]="14" aria-hidden="true"></lucide-angular>
      </button>
    </div>
  </div>
</div>
